// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58908c59","337":"abb35c03","455":"634e062f"}[chunkId] + ".chunk.js";
};